function addBodyClasses() {
  let isAndroid = /(android)/i.test( navigator.userAgent );

  if (isAndroid) {
    document.body.classList.add( 'is-android' );
  }
}

export default {
  init() {
    addBodyClasses();
  },
};